import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-483b111a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header_wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "header",
    class: _normalizeClass({ fixed: $setup.isHeaderFixed })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "menu_btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toggleOpen && $setup.toggleOpen(...args)))
      }, _hoisted_5),
      _createElementVNode("span", {
        class: "logo",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/')))
      }, "META HEALTH")
    ])
  ], 2))
}